import { render, staticRenderFns } from "./NotificationLayer.vue?vue&type=template&id=29f65b49"
import script from "./NotificationLayer.vue?vue&type=script&lang=js"
export * from "./NotificationLayer.vue?vue&type=script&lang=js"
import style0 from "./NotificationLayer.vue?vue&type=style&index=0&id=29f65b49&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports